export default {
  NODE_ENV: process.env.NODE_ENV || "development",
  PORT: process.env.PORT || 1337,
  API_BASE_URL:
    process.env.NODE_ENV == "production" || true //TODO: delete || true
      ? "https://lcc.eurac.edu/api/v1/"
      : "http://localhost:4000/api/v1/",
  INTERCOM_APP_ID: "yxqtem8i",
};
